import { useFeatureFlag } from 'v2/core/clients/featureFlag';
import { FeatureFlagType } from 'v2/core/clients/featureFlag/flags';

const featureFlag: FeatureFlagType = {
  name: 'instagram_integration',
  fallback: false,
};

export const useIsInstagramIntegrationEnabled = () => {
  const [, isInstagramIntegrationEnabled] = useFeatureFlag(featureFlag);

  return isInstagramIntegrationEnabled;
};
